import { Message } from '@qs/ui'
import { fetchImportResultUrl } from '@/api/public_import'

function fetchHistoryUrl(taskId) {
  if (!taskId) {
    Message({
      type: 'error',
      message: '查询失败，缺失taskId，请检查',
    })
    return
  }
  fetchImportResultUrl({ taskId }).then((res) => {
    if (res && res.code === 1 && res.data) {
      const ele = document.createElement('a')
      ele.setAttribute('href', res.data)
      ele.style.display = 'none'
      document.body.appendChild(ele)
      ele.click()
      document.body.removeChild(ele)
    } else {
      Message({
        type: 'error',
        message: '服务器异常，请稍后重试',
      })
    }
  })
}

export {
  fetchHistoryUrl,
}
